import type { IconSvgObject } from './types';

const HeartMinusIcon: IconSvgObject = [
  ["path", { d: "M14 15.9999H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.802 12.4999C21.5335 11.2425 22 9.9483 22 8.69438C22 5.82557 19.8947 3.49994 17 3.49994C15.5 3.49994 14 3.99994 12 5.99994C10 3.99994 8.5 3.49994 7 3.49994C4.10526 3.49994 2 5.82557 2 8.69438C2 13.0348 7.58942 17.8579 10.4107 19.9676C11.3601 20.6776 12.6399 20.6776 13.5893 19.9676C13.7814 19.824 13.9863 19.6677 14.2015 19.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HeartMinusIcon;
